export default Object.freeze({
  Horizontal: 1,
  Vertical: 2,
});
